import { render, staticRenderFns } from "./RemoveResourceButton.vue?vue&type=template&id=50deb250&scoped=true"
import script from "./RemoveResourceButton.vue?vue&type=script&lang=js"
export * from "./RemoveResourceButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveResourceButton.vue?vue&type=style&index=0&id=50deb250&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50deb250",
  null
  
)

export default component.exports